import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {positionChapters} from 'storyboard/actions/position-chapter-actions';
import StoryboardNav from 'storyboard/components/storyboard-nav';

class StoryboardNavContainer extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    enums: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    openModal: PropTypes.func,
  };

  static defaultProps = {
    dispatch: () => {},
    openModal: () => {},
  };

  constructor() {
    super();
    this.positionChapters = this.positionChapters.bind(this);
  }

  positionChapters(chapters) {
    this.props.dispatch(positionChapters(chapters));
  }

  render() {
    return (
      <StoryboardNav
        data={this.props.data}
        enums={this.props.enums}
        location={this.props.location}
        openModal={this.props.openModal}
        positionChapters={this.positionChapters}
      />
    );
  }
}

export default connect()(StoryboardNavContainer);
